const state = {
  popupTitle: '',
}

const mutations = {
  setPopupTitle(state, payload) {
    state.popupTitle = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
